module.exports = __webpack_public_path__ + "static/media/avatar1.dcb836f8.jpg";